export default import.meta.ROLLUP_FILE_URL_o$BCv$ko;